import { render, staticRenderFns } from "./TheDescription.vue?vue&type=template&id=997c1cb2&"
import script from "./TheDescription.vue?vue&type=script&lang=js&"
export * from "./TheDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports